import React, { Component } from 'react';
import axiosInstance from '../../redux/axiosInstance/';
import moment from 'moment';
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  Spinner,
} from 'reactstrap';
import Header from 'components/Headers/Header.js';

export default class AgentDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agent: null,
      loading: true,
      error: null,
      leads: [],
      leadsLoading: false,
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    const passedAgent = this.props.location?.state?.agentData || null;

    if (passedAgent) {
      this.setState({ agent: passedAgent, loading: true });
    }

    if (!id || id === 'undefined') {
      this.setState({ loading: false });
      return;
    }

    // Fetch full agent data (qa_answers, pvq_answers, services_offered)
    axiosInstance
      .get(`/agent/agents/views/unique/${id}`)
      .then((response) => {
        const fullAgent = response.data.data;
        if (fullAgent) {
          this.setState({ agent: fullAgent, loading: false });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => this.setState({ loading: false }));

    // Fetch leads for this agent
    this.setState({ leadsLoading: true });
    axiosInstance
      .get(`/leads/admin/list?agent_id=${id}`)
      .then((response) => {
        this.setState({ leads: response.data.data || [], leadsLoading: false });
      })
      .catch(() => this.setState({ leadsLoading: false }));
  }

  renderField(label, value) {
    if (!value && value !== 0 && value !== false) return null;
    return (
      <tr>
        <th style={{ width: '35%' }}>{label}</th>
        <td>{String(value)}</td>
      </tr>
    );
  }

  renderList(label, items) {
    if (!items || !items.length) return null;
    return (
      <tr>
        <th style={{ width: '35%' }}>{label}</th>
        <td>{Array.isArray(items) ? items.map((i) => (typeof i === 'object' ? i.name : i)).join(', ') : items}</td>
      </tr>
    );
  }

  render() {
    const { agent, loading, error } = this.state;

    return (
      <>
        <Header />
        <Container className="mt--7" fluid>
          <Row className="mb-3">
            <Col>
              <Button color="secondary" size="sm" onClick={() => this.props.history.goBack()}>
                &larr; Back
              </Button>
            </Col>
          </Row>

          {loading && (
            <Row>
              <Col className="text-center py-5">
                <Spinner color="primary" />
              </Col>
            </Row>
          )}

          {error && (
            <Row>
              <Col>
                <div className="alert alert-danger">{error}</div>
              </Col>
            </Row>
          )}

          {agent && (
            <>
              {/* Header card */}
              <Row className="mb-4">
                <Col>
                  <Card className="shadow">
                    <CardBody>
                      <Row className="align-items-center">
                        {agent.image_url?.completedUrl && (
                          <Col xs="auto">
                            <img
                              src={agent.image_url.completedUrl}
                              alt="agent"
                              style={{ width: 80, height: 80, borderRadius: '50%', objectFit: 'cover' }}
                            />
                          </Col>
                        )}
                        <Col>
                          <h2 className="mb-1">
                            {agent.first_name} {agent.last_name}
                          </h2>
                          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            <Badge color={agent.is_activated ? 'success' : 'warning'}>
                              {agent.is_activated ? 'Activated' : 'Not Activated'}
                            </Badge>
                            <Badge color={agent.is_claimed ? 'info' : 'secondary'}>
                              {agent.is_claimed ? 'Claimed' : 'Unclaimed'}
                            </Badge>
                            <Badge color={agent.isOnline ? 'success' : 'light'}>
                              {agent.isOnline ? 'Online' : 'Offline'}
                            </Badge>
                          </div>
                        </Col>
                        <Col xs="auto" className="text-right text-muted small">
                          <div>Views: {agent.view_count || 0}</div>
                          {agent.createdAt && (
                            <div>Joined: {moment(agent.createdAt).format('MMM D, YYYY')}</div>
                          )}
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Row>
                {/* Contact & Location */}
                <Col lg="6" className="mb-4">
                  <Card className="shadow h-100">
                    <CardHeader className="border-0">
                      <h4 className="mb-0">Contact &amp; Location</h4>
                    </CardHeader>
                    <CardBody className="p-0">
                      <Table className="table mb-0">
                        <tbody>
                          {this.renderField('Email', agent.company_email)}
                          {this.renderField('Phone', agent.phone)}
                          {this.renderField('Website', agent.website)}
                          {this.renderField('Fax', agent.fax)}
                          {this.renderField('Address 1', agent.address1)}
                          {this.renderField('Address 2', agent.address2)}
                          {this.renderField('Address 3', agent.address3)}
                          {this.renderField('City', agent.city)}
                          {this.renderField('State', agent.state)}
                          {this.renderField('Zipcode', agent.zipcode)}
                          {this.renderField('Country', agent.country)}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </Col>

                {/* Professional Info */}
                <Col lg="6" className="mb-4">
                  <Card className="shadow h-100">
                    <CardHeader className="border-0">
                      <h4 className="mb-0">Professional Info</h4>
                    </CardHeader>
                    <CardBody className="p-0">
                      <Table className="table mb-0">
                        <tbody>
                          {agent.bio && (
                            <tr>
                              <th colSpan="2">Bio</th>
                            </tr>
                          )}
                          {agent.bio && (
                            <tr>
                              <td colSpan="2">{agent.bio}</td>
                            </tr>
                          )}
                          {this.renderList('Industry', agent.industry)}
                          {this.renderList('Education', agent.education)}
                          {this.renderList('Affiliations', agent.affiliations)}
                          {this.renderList('Languages', agent.languages)}
                          {this.renderList('Skills', agent.skills)}
                          {this.renderList('Services Offered', agent.services_offered)}
                          {this.renderField('Facebook', agent.facebook)}
                          {this.renderField('Twitter', agent.twitter)}
                          {this.renderField('Instagram', agent.instagram)}
                          {this.renderField('Online Availability', agent.online_availability ? 'Yes' : 'No')}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              {/* Q&A Answers */}
              {agent.qa_answers && agent.qa_answers.length > 0 && (
                <Row className="mb-4">
                  <Col>
                    <Card className="shadow">
                      <CardHeader className="border-0">
                        <h4 className="mb-0">Questions &amp; Answers</h4>
                      </CardHeader>
                      <CardBody className="p-0">
                        <Table className="table mb-0">
                          <thead className="thead-light">
                            <tr>
                              <th style={{ width: '45%' }}>Question</th>
                              <th>Answer</th>
                            </tr>
                          </thead>
                          <tbody>
                            {agent.qa_answers.map((qa, i) => (
                              <tr key={i}>
                                <td>{qa.question_text}</td>
                                <td>
                                  {Array.isArray(qa.answer)
                                    ? qa.answer.join(', ')
                                    : qa.answer}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}

              {/* Private Q&A */}
              {agent.pvq_answers && agent.pvq_answers.length > 0 && (
                <Row className="mb-4">
                  <Col>
                    <Card className="shadow">
                      <CardHeader className="border-0">
                        <h4 className="mb-0">Private Questions &amp; Answers</h4>
                      </CardHeader>
                      <CardBody className="p-0">
                        <Table className="table mb-0">
                          <thead className="thead-light">
                            <tr>
                              <th style={{ width: '45%' }}>Question</th>
                              <th>Answer</th>
                            </tr>
                          </thead>
                          <tbody>
                            {agent.pvq_answers.map((qa, i) => (
                              <tr key={i}>
                                <td>{qa.question_text}</td>
                                <td>
                                  {Array.isArray(qa.answer)
                                    ? qa.answer.join(', ')
                                    : qa.answer}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}

              {/* Leads */}
              <Row className="mb-4">
                <Col>
                  <Card className="shadow">
                    <CardHeader className="border-0">
                      <h4 className="mb-0">Leads &amp; Matching</h4>
                    </CardHeader>
                    {this.state.leadsLoading ? (
                      <CardBody className="text-center py-4">
                        <Spinner color="primary" size="sm" /> Loading leads...
                      </CardBody>
                    ) : this.state.leads.length === 0 ? (
                      <CardBody className="text-muted text-center py-4">
                        No leads found for this agent.
                      </CardBody>
                    ) : (
                      <CardBody className="p-0">
                        <Table className="table mb-0" responsive>
                          <thead className="thead-light">
                            <tr>
                              <th>Service</th>
                              <th>Description</th>
                              <th>Location</th>
                              <th>Match Reason</th>
                              <th>Status</th>
                              <th>Unlocked</th>
                              <th>Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.leads.map((lead) => {
                              const sr = lead.service_request_id;
                              return (
                                <tr key={lead._id}>
                                  <td>{sr?.tax_service_id?.name || '—'}</td>
                                  <td style={{ maxWidth: 200, whiteSpace: 'normal' }}>
                                    {sr?.description || '—'}
                                  </td>
                                  <td>{sr?.location || '—'}</td>
                                  <td style={{ maxWidth: 220, whiteSpace: 'normal' }}>
                                    {lead.match_reason || '—'}
                                  </td>
                                  <td>
                                    <Badge color={
                                      lead.status === 'completed' ? 'success' :
                                      lead.status === 'unlocked' ? 'info' :
                                      lead.status === 'viewed' ? 'warning' : 'secondary'
                                    }>
                                      {lead.status}
                                    </Badge>
                                  </td>
                                  <td>{lead.is_unlocked ? 'Yes' : 'No'}</td>
                                  <td>{lead.createdAt ? moment(lead.createdAt).format('MMM D, YYYY') : '—'}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </CardBody>
                    )}
                  </Card>
                </Col>
              </Row>
            </>
          )}
        </Container>
      </>
    );
  }
}
